module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ResourcesWithCategories extends DataTemplateBase implements IDataTemplate {

        protected resourceCategories: ResourceCategoriesCollection;
        protected resources: ResourcesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.resourceCategories;
        }

        get leafCollection() {
            return this.resources;
        }

        reconnectLeafCollectionModel(model) {
            this.leafCollection.connectedModel = model[this.properties[1]];
        }

        get totalSelectedCount(): number {
            return this.resources.value.length;
        }

        private _required: boolean;
        get required(): boolean {
            return this._required;
        }

        set required(value : boolean) {
            this._required = value;
            this.updateRequiredValidator(value, this.collection);
        }

        constructor(model: Dictionary<any>, protected properties: string[], { criteria, modalService, $scope, $filter, required }: IDataTemplateOptions) {
            super(model, properties, criteria);
            
            this.resourceCategories = new ResourceCategoriesCollection(this.model[properties[0]], [], {
                criteria
            });

            this.resources = new ResourcesCollection(this.model[properties[1]], [], {
                criteria
            });

            this.resources.setParentCollection(this.resourceCategories, ResourcesToCategoriesStrategy);

            if (this.model["showAllSelected"] == false) {
                this.showAllSelected = false;
            }

            this.title = 'LABEL_RESOURCE';
            this.allSelectedLabel = 'LABEL_ALL_RESOURCES';
            this.totalSelectedMessage = 'LABEL_TOTAL_RESOURCES_SELECTED';
            this.filters = [
                new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_RESOURCES' }, this)
            ];
            this.resources.addFilters(...this.filters as IInteractiveFilter[]);
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this.resources.setWatchers(scope);
        }
    }
}